import { makeStyles } from '@material-ui/core'

export const useStyles = makeStyles((theme) => ({
  headerContainer: {
    display: 'flex',
    width: '100%',
    backgroundColor: '#ffff',
    flexDirection: 'column',
    boxShadow: '0px 4px 4px rgba(6, 0, 173, 0.15)',
    minHeight: theme.spacing(15),
    marginBottom: theme.spacing(),
    [theme.breakpoints.up('lg')]: {
      alignItems: 'center',
      flexDirection: 'row',
      padding: theme.spacing(0, 10)
    }
  },
  dateContainer: {
    padding: theme.spacing(0, 5),
    color: '#ffff',
    height: 50,
    display: 'flex',
    alignItems: 'center',
    backgroundColor: theme.palette.primary.main,
    '& h6': {
      fontWeight: 500,
      flexGrow: 1,
      fontSize: '1.25rem',
      textTransform: 'uppercase'
    },
    [theme.breakpoints.up('lg')]: {
      padding: 0,
      position: 'absolute',
      backgroundColor: '#ffff',
      flexShrink: 0,
      color: theme.palette.primary.main
    }
  },
  eventName: {
    textAlign: 'center',
    padding: theme.spacing(2, 4),
    fontSize: '1rem',
    flexGrow: 1,
    [theme.breakpoints.up('lg')]: {
      fontSize: '1.25rem',
      padding: theme.spacing(2, 13)
    }
  },
  messageContainer: {
    backgroundColor: '#ffff',
    height: '69.1vh',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    textAlign: 'center',
    padding: '0 20px'
  },
  notFoundContainer: {
    display: 'flex',
    flexDirection: 'column',
    minHeight: '71.2vh',
    justifyContent: 'center',
    alignItems: 'center',
    ' & h5': {
      fontWeight: 600
    }
  }
}))
